import React from "react";

import ArchiveFilter from "./filters/ArchiveFilter";
import CalendarFilter from "./filters/CalendarFilter";
import CheckboxFilter from "./filters/CheckboxFilter";
import CreatorFilter from "./filters/CreatorFilter";
import InputFilter from "./filters/InputFilter";
import KeywordFilter from "./filters/KeywordFilter";
import MultiCheckboxFilter from "./filters/MultiCheckboxFilter";

export type FilterProps = {
  name: string | undefined;
  setFilter: ((updater: any) => void) | undefined;
  filterValue: any;
  defaultValues: string[] | undefined;
};

export const FiltersTypes = {
  roles: (filterProps: FilterProps) => <MultiCheckboxFilter {...filterProps} />,
  regions: (filterProps: FilterProps) => (
    <MultiCheckboxFilter {...filterProps} />
  ),
  status: (filterProps: FilterProps) => <CheckboxFilter {...filterProps} />,
  theme: (filterProps: FilterProps) => <CheckboxFilter {...filterProps} />,
  id: (filterProps: FilterProps) => <InputFilter {...filterProps} />,
  name: (filterProps: FilterProps) => <InputFilter {...filterProps} />,
  label: (filterProps: FilterProps) => <InputFilter {...filterProps} />,
  created_at: (filterProps: FilterProps) => <CalendarFilter {...filterProps} />,
  author: (filterProps: FilterProps) => <CreatorFilter {...filterProps} />,
  archived: () => <ArchiveFilter />,
  keyword: () => <KeywordFilter />,
};
